<template>
  <div :class="{ cover: !$store.getters.showHeader }">
    <div class="invitationDetails-header">
      <van-search
        :style="{ color: focus ? '#FF9A34' : '#ECECEC' }"
        class="invitationDetails-search"
        v-model.trim="phone"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @clear="onClear"
        @focus="focus = true"
        @blur="focus = false"
        type="number"
        maxlength="11"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <template v-if="isSearch">
      <!-- 手机号码格式不正确 -->
      <div
        class="incorrect_format"
        v-if="!correct"
      >
        <img
          src="../../assets/img/incorrect_format.png"
          alt=""
        >
      </div>
      <!-- 用户未注册悦买 -->
      <div
        class="notHave"
        v-if="searchInfo.hasRegister == 0 && correct"
      >
        <img
          src="http://img.yamyamyam.com/img/defaultHeadPicture.png"
          alt=""
        >
        <p>未注册悦买</p>
      </div>
      <!-- 用户注册悦买 -->
      <div
        class="invitationDetails-item"
        v-if="searchInfo.hasRegister == 1 && correct"
      >
        <div class="content">
          <div class="name flex-between">
            <span>{{searchInfo.phone}}</span>
            <span :class="[searchInfo.hasFirstOrder == 1 ? 'isFirst' : 'notFirst']">{{searchInfo.hasFirstOrder == 1? "已下首单" : "未下首单"}}</span>
          </div>
          <div class="timer">注册时间：{{searchInfo.registerTime}}</div>
          <div
            class="timer"
            v-if="searchInfo.createTime"
          >下单时间：{{searchInfo.createTime}}</div>
          <div class="timer" v-if="searchInfo.invitePhone">邀请人：{{searchInfo.invitePhone}}</div>
          <div class="timer" v-else>自行注册</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="invitationDetails-item flex-between van-hairline--bottom"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="headpic">
          <img
            :src="imgPrex + item.headpic"
            alt
          />
        </div>
        <div class="content">
          <div class="name van-ellipsis">{{item.nickname}}</div>
          <div class="timer">{{item.registerTime}}</div>
        </div>
      </div>
      <div
        class="notInvitationDetails"
        v-if="!list.length && !loading"
      >
        <img
          src="../../assets/img/empty.png"
          alt=""
        >
        <p>暂无邀请记录</p>
      </div>
    </template>
  </div>
</template>

<script>
import { inviteInfo, getUserByPhone } from "@/api/join";
export default {
  data() {
    return {
      list: [],
      loading: false,
      phone: "",
      isSearch: false,
      searchInfo: {
        hasRegister: "1", //是否已经注册，1是，0否
      },
      correct: true, // 输入手机格式是否正确
      focus: false
    }
  },
  methods: {
    onClear() {
      this.correct = true;
      this.isSearch = false;
    },
    onSearch() {
      this.isSearch = true;
      if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.phone)) {
        this.correct = true;
        getUserByPhone({
          phone: this.phone
        }).then((res) => {
          if (res.appStatus.errorCode == 0) {
            this.searchInfo = res.content;
          }
        })
      } else {
        this.correct = false;
      }
    },
  },
  mounted() {
    this.loading = true;
    inviteInfo({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.loading = false;
        this.list = res.content.list;
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.cover {
  .invitationDetails-search {
    top: 0;
  }
}
.invitationDetails-header {
  height: 52px;
}
.invitationDetails-search {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  height: 52px;
  padding-left: 15px;
  z-index: 666;
  .van-search__content {
    margin: 4px 0;
    background-color: #ffffff;
    border: 1px solid;
    border-radius: 16px;
  }
  .van-search__action {
    padding: 0 15px;
  }
}
.invitationDetails-item {
  width: 345px;
  min-height: 60px;
  margin: 0 15px;
  padding: 15px 0;
  .headpic {
    width: 61px;
    height: 61px;
    margin-right: 12px;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .content {
    flex: 1;
    overflow: hidden;
    .name {
      font-size: 14px;
      font-weight: 800;
      color: #333333;
      .isFirst {
        display: inline-block;
        padding: 1px 4px;
        font-size: 12px;
        font-weight: 400;
        color: #ff9a34;
        background-color: #ffead8;
      }
      .notFirst {
        display: inline-block;
        padding: 1px 4px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        background-color: #f5f5f5;
      }
    }
    .timer {
      margin-top: 8px;
      font-size: 12px;
      color: #666666;
    }
  }
}
.notInvitationDetails {
  width: 100%;
  height: 100%;
  margin-top: 150px;
  text-align: center;
  img {
    width: 140px;
    height: 140px;
    margin: 0 auto;
    display: block;
  }
  p {
    margin-top: 24px;
    font-size: 14px;
    color: #333333;
  }
}
.notHave {
  margin-top: 38px;
  font-size: 15px;
  color: #a3a2a2;
  text-align: center;
  img {
    width: 72px;
    height: 72px;
  }
}
.incorrect_format {
  margin-top: 30px;
  text-align: center;
  img {
    width: 214px;
    height: 143px;
  }
}
</style>